import { TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

type htmlGetter = (item: unknown) => string;
type linkGetter = (item: unknown) => string;
type linkQueryParamsGetter = (item: unknown) => { [key: string]: string | number };
type actionGetter = (item: unknown) => unknown;
type searchFunc = (item: unknown, searchString: string) => boolean;
type isSelected$ = (item: unknown) => Observable<boolean>;
type linkIsExternalGetter = (index: number, item: unknown) => boolean;
/**
 * Remarks: <br/>
 * Date: __08/05/2025__
 * - For [Angular Material](https://material.angular.dev/cdk/scrolling/api#CdkVirtualForOf) trackBy, it needs to be referenced -> trackBySetter -> ($idx, itm) => string
 * - For the [Angular Framework](https://v20.angular.dev/api/core/@for#syntax), trackBy needs to be invoked -> trackBySetter($idx, itm) => string
 * - If this is confusing to you, yes it is.
 *
 * Please reference `simple-list.component.html` for specific reference examples.
 * */
type trackBySetter = (index: number, item: unknown) => string;

export const defaultTrackBySetter: trackBySetter = (index: number, _: unknown) => index.toString();

export interface ISimpleListConfig {
	html: htmlGetter;
	placeholder?: string;
	searchFunc?: searchFunc;
	link?: linkGetter;
	/** Query params for the (internal) router link, e.g. a marking-period hint for combined-term courses. */
	linkQueryParams?: linkQueryParamsGetter;
	linkTarget?: string;
	linkIsExternal?: linkIsExternalGetter;
	action?: actionGetter;
	customTemplate?: TemplateRef<unknown>;
	customActionsTemplate?: TemplateRef<unknown>;
	displaySearchBarCount?: number;
	searchBoxGray?: boolean;
	itemPadLeft?: string;
	isSelected$?: isSelected$;
	hover?: boolean;
	enableVirtualScroll?: boolean;
	/** Fixed row height (px) for the virtual-scroll viewport. Must match the rendered row height,
	 * or cdk mis-positions rows. Defaults to 40. */
	virtualItemSize?: number;
	showNoResults?: boolean;
	customNoResultsTemplate?: TemplateRef<unknown>;
	customHeight?: string;
	trackBy?: trackBySetter;
}
